var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"100px","margin-right":"15px"}},[_c('b-form-select',{class:this.variant == 'light' ? 'white-select' : 'gray-select',staticStyle:{"height":"41px !important"},attrs:{"value":_vm.$store.state.year,"options":_vm.yearOptions},on:{"change":_vm.onChange}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1c225f8c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/YearSelect.vue
// module id = 6MXH
// module chunks = 1